import axios from 'axios'
import ResourceService from './resource.service'
import config from '@/config' // Import your centralized config

class AuthService extends ResourceService {
  static get resource() {
    return 'auth'
  }

  static exchangeAuthorizationCode(params) {
    const headers = {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
      },
      url = config.keyCloakURL + `/token`

    return new Promise((resolve, reject) => {
      axios
        .post(url, params, headers)
        .then(({ data }) => {
          resolve(data)
        })
        .catch((error) => {
          reject(error)
        })
    })
  }

  static refreshToken(params) {
    const headers = {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
      },
      url = config.keyCloakURL + `/token`

    return new Promise((resolve, reject) => {
      axios
        .post(url, params, headers)
        .then(({ data }) => {
          resolve(data)
        })
        .catch((error) => {
          reject(error)
        })
    })
  }
}

export default AuthService
